import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, Auth, User as UserImpl } from "firebase/auth";
import { isRoles, User } from '~/models/User';
import { isDefaultTenantScreen, screenTenantID } from '~/module/tenant/tenant';

const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true';
const emulatorLocation = import.meta.env.VITE_EMULATOR_LOCATION ?? "http://localhost:8199";

const getFirebaseConfig = () => {
  if (import.meta.env.VITE_APP_ENV === 'production') {
    return {
      apiKey: "AIzaSyCev07tkLn7txn-wzydqwyi46Cc--b7hIE",
      authDomain: "roxx-common-company-auth-prod.firebaseapp.com",
      projectId: "roxx-common-company-auth-prod",
      storageBucket: "roxx-common-company-auth-prod.appspot.com",
      messagingSenderId: "54058844715",
      appId: "1:54058844715:web:d637c553d67e6ff147206e"
    }
  }
  if (import.meta.env.VITE_APP_ENV === 'staging') {
    return {
      apiKey: "AIzaSyCHSMK7FuakLHPC_kI7M4pidabsoeckpVE",
      authDomain: "roxx-common-company-auth-stg.firebaseapp.com",
      projectId: "roxx-common-company-auth-stg",
      storageBucket: "roxx-common-company-auth-stg.appspot.com",
      messagingSenderId: "920292384684",
      appId: "1:920292384684:web:36bb2412c4ac019247a409"
    }
  }
  return {
    apiKey: "AIzaSyA5rB0PVo4yDJmSH9dsgwMGhkYPcebWszk",
    authDomain: "roxx-ab-sandbox.firebaseapp.com",
    projectId: "roxx-ab-sandbox",
    storageBucket: "roxx-ab-sandbox.appspot.com",
    messagingSenderId: "830347971716",
    appId: "1:830347971716:web:0093d79c22b47ac05446d1"
  };
}

let client: Auth

export function getClient() {
  if (!client) {
    init()
  }
  return client
}


export function init(): void {
  const app = initializeApp(getFirebaseConfig());
  const auth = getAuth(app)
  if (useEmulator) {
    connectAuthEmulator(auth, emulatorLocation);
  }
  // 認証は画面のテナント（ビルド時に決まる）のプールに対して行う。ここで一度設定すれば
  // サインイン・パスワード再設定の確定・多要素認証に伴う操作のすべてが同じプールを使う。
  // 既定テナントは GCIP のデフォルトプールであり、テナント識別子を設定しない
  // （roxx を設定すると存在しない GCIP テナントを指し、既存のログインが壊れる）。
  if (!isDefaultTenantScreen()) {
    auth.tenantId = screenTenantID()
  }
  client = auth
}

export async function getUser(): Promise<User | null> {
  const auth = getClient()
  await auth.authStateReady()
  const user = auth.currentUser
  if (!user) {
    return null
  }
  return createUser(user)
}

export async function createUser(user: UserImpl): Promise<User> {
  const idTokenResult = await user.getIdTokenResult();
  const roles = isRoles(idTokenResult.claims.roles) ? idTokenResult.claims.roles : [];
  const newUser = new User(user, roles);
  return newUser
}
